import React from 'react';
import Contact from '../components/Contact';

const ContactPage = () => {
  return (
    <div className="page-container">
      <Contact />
    </div>
  );
};

export default ContactPage;

